import React from 'react';
import axios from "axios";
import { useState, useEffect, useMemo } from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrash, faTrashAlt } from '../../../node_modules/@fortawesome/free-solid-svg-icons/index';
import { useNavigate } from "react-router-dom";

const CropsIntervalDays = () => {
    const navigate = useNavigate();
    const [value, setvalue] = useState("");
    const [cropsIntervalDaysData, setCropsIntervalDaysData] = useState([]);
    const [deleteCode, setDeleteCode] = useState({});
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropInterval/GetCropIntervalList`);
            setCropsIntervalDaysData(result.data.dataContent);
            setIsFetching(false);
        };
        fetchData();
    }, []);

    function removed() {
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "none";
    }


    function viewData(value) {
        var x = document.createElement("a")
        x.id = "mpopupLink";
        var mpopup = document.getElementById('mpopupBox');
        mpopup.style.display = "block";

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            "cropIntervalCode": value.cropIntervalCode
        });

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropInterval/GetCropIntervalListByParam`, requestOptions)
            .then(response => response.json())
            .then(result => {
                let userData = result.dataContent[0];

                document.getElementById("modal-content").innerHTML = '<h5 class="formgrouping">Crop Interval Details</h5> <div class="row"> <div class="col-md-4"> <h6>State Name</h6> <p>' + userData.stateName + '</p> </div> <div class="col-md-4"> <h6>District Name</h6> <p>' + userData.districtName + '</p> </div> <div class="col-md-4"> <h6>Crop Name</h6> <p>' + userData.cropName + '</p> </div> <div class="col-md-4"> <h6>Crop Interval Days</h6> <p>' + userData.cropIntervalDays + '</p> </div> <div class="col-md-4"> <h6>Is Visible</h6> <p>' + userData.visibility + '</p> </div> <div class="col-md-4"> <h6>Is Active</h6> <p>' + userData.isActive + '</p> </div> </div>';

            })
            .catch(error => console.log('error', error));
    }

    function deleteData(value) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify(deleteCode);

        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };

        fetch(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropInterval/DeleteCropInterval`, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (JSON.parse(result).success == true) {
                    fetchData2()
                }
            })
            .catch(error => console.log('error', error));
    }
    async function fetchData2() {
        const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/cropInterval/GetCropIntervalList`);
        setCropsIntervalDaysData(result.data.dataContent);
    }

    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1
            },
            {
                accessorKey: 'stateName',
                header: 'State Name',
            },
            {
                accessorKey: 'districtName',
                header: 'District Name',
            },
            {
                accessorKey: 'cropName',
                header: 'Crop Name',
            },
            {
                accessorKey: 'cropIntervalDays',
                header: 'Crop Interval(Days)',
            },
    
            {
                accessor: '',
                header: 'Actions',
                Cell: cell => <><i className="btn text-success" type="button" onClick={(e) => viewData(cell.row.original)} > <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-primary" type="button" data-bs-toggle="modal" data-bs-target="#myModal" onClick={() => navigate("/master/AddcropsIntervalDays", { state: { cropsIntervalCode: cell.row.original } })}><FontAwesomeIcon icon={faPencil} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#myDelete" onClick={() => setDeleteCode({ "cropintervalcode": cell.row.original.cropIntervalCode, "ModifiedByUC": cell.row.original.modifiedByUC })} > <FontAwesomeIcon icon={faTrashAlt} /></i></>

            },
        ],
        [],
    );

    return (
        <>
           
            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-center justify-content-between">
                    <nav>
                        <h1>Crops Interval Days</h1>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">User Management</li>
                            <li className="breadcrumb-item active">Users</li>
                        </ol>
                    </nav>
                    <button type="button" className="btn btn-success" onClick={() => navigate("/master/AddcropsIntervalDays")}>Add New</button>
                </div>
                <section className="section">
                    <div className="row justify-content-lg-center">
                        <div className="col-lg-12 ">
                            <div className="card">
                                <MaterialReactTable
                                    columns={columns}
                                    data={cropsIntervalDaysData}
                                    enableColumnOrdering={true}
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-6">
                        </div>
                    </div>
                </section>
                <div className="modal" id="myModal">
                    <div className="modal-dialog">
                        <div className="modal-content">

                            <div className="modal-header">
                                <button type="button" className="btn-close" data-bs-dismiss="modal">X</button>
                            </div>

                            <div className="modal-body">
                                <label htmlFor="Designation" className="form-label">Add New Scheme</label>
                                <input type="text" className="form-control" placeholder="Add New Seasone" />
                            </div>

                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal">Close</button>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="modal fade" id="myDelete" data-bs-backdrop="myDelete" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="deleteLabel"></h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                            </div>
                            <div className="modal-body">
                                <h6 id="deleteHeading">Are you sure you want to delete this item?</h6>
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                                <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                            </div>

                        </div>
                    </div>
                </div>

            </main>
         

            <div className="modal fade" id="staticBackdrop_user" data-bs-backdrop="staticBackdrop_user" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">
                            <h6 id="deleteHeading">Are you sure you want to delete this item?</h6>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={deleteData}>Yes</button>
                            <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade viewDetails" id="viewDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="viewDetailsLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="viewDetailsLabel"></h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body" id="modal-body">

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="mpopupBox" className="modal">
                <div className="modal-content" >
                    <div className="modal-header">
                        <h2>View Details</h2>
                        <button type="button" className="btn-close" onClick={removed}>X</button>
                    </div>
                    <div className="madal-body" id="modal-content" >
                    </div>
                    <div className="modal-footer">
                   
                    </div>
                </div>
            </div>
        </>
    )
}


export default CropsIntervalDays;